import { route } from 'ziggy';

export const backendRoute = (name, params = undefined, absolute = false) => {
    // On staging + production BE routes are prefixed with "/profil"
    const prefix = process.env.NODE_ENV === 'development' ? '' : '/profil';
    return prefix + route(name, params, absolute);
}
